import React, { useContext, useState } from 'react'

import { CalendarOutlined, CaretRightOutlined, CarOutlined, CreditCardOutlined, EuroCircleOutlined,ProductOutlined } from '@ant-design/icons'
import { Badge, Col, Collapse, Row, Typography } from 'antd'

import { CreateAudienceDataContext } from '../../../../../helpers/Context'
import MarketingFiltersToggleCollapse from '../MarketingFiltersToggleCollapse'


export default function BookingFilters({ form }) {
  
  const {   
      setactiveKeysBooking,
      formShippingPayments,
      activeKeysBooking,
      colorBooking,
      formBookings,
      formOrders,
      keys,
  } = useContext(CreateAudienceDataContext);

  // Funzione per espandere o contrarre tutti i pannelli
  const toggleAll = () => {
    if (activeKeysBooking.length === 0) {
      // Espandi tutti i pannelli, ottieni le chiavi dei pannelli
      setactiveKeysBooking(keys);
    } else {
      // Contrai tutti i pannelli (set activeKeys to empty array)
      setactiveKeysBooking([]);
    }
  };
  
   
  return (
    <>
      <Row justify={"end"} gutter={[10,10]} className='w-100'> 
        <Col>
          <MarketingFiltersToggleCollapse onClick={toggleAll} activeKeys={activeKeysBooking}/>
        </Col>
      </Row>
      <Collapse
        activeKey={activeKeysBooking}
        onChange={setactiveKeysBooking}
        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
        expandIconPosition='end'
        size='large'
        bordered={false}
        items={[
          // -------- inizio array di elementi accordion --------

          // -------- gestione prenotazione ---------
          {
            key: '1',
            forceRender:true,
            label: (
              <div className='flex-wrap gap-10 align-center'>
                    <div className='flex align-center gap-5'>
                      <Typography className='fs-16 flex align-center gap-10'>
                        <div className='fs-16'><CalendarOutlined /></div>
                        Date di Prenotazione
                      </Typography>
                    <Badge color={formBookings?.length ? colorBooking : ""} count={formBookings?.length}/>
                    </div>
                  <Typography className='fs-12 opacity-05 flex align-center gap-5'>
                    Definisci gli utenti in base alle date in cui hanno prenotato
                  </Typography>
              </div>
            ),
            
            children:
               <div className='mt-10'>
              </div>,
          },
          // -------- gestione prenotazione ---------

          
          // -------- fine array di elementi accordion --------
        ]}
      />
    </>
  )
}
